import React from 'react';
import _ from 'lodash';

import { getBillingDashboardPageBreadcrumb } from '../Billing/BillingDashboardPage';

import Field from '../../Fields/Field';
import InputSelectField from '../../Fields/InputSelectField';
import DataTable from '../../Fields/DataTable';

import ProcessingIndicator from '../../Common/ProcessingIndicator';
import PageHeader from '../../Common/PageHeader';
import NavigationBreadcrumbs from '../../Common/NavigationBreadcrumbs';

import Rate from '../../../Entities/Rate';

import { queryListRates } from '../../../Queries';

import { getFacility } from '../../../Utils/facility';

import '../Page.scss';
import './RateListPage.scss';

class RateListPage extends React.Component {
  state = {
    pageInitializationComplete: false,
    pageInitializationErrors: [],
    rateListQueryInProgress: false,
    rateListQueryErrors: [],
    rates: [],
    ratesFilter: {
      inputs: {
        active: true
      }
    }
  };

  ratesFilterFieldConfiguration = {};

  rateData = {
    rawValues: [],
    filteredRowCount: 0,
    sortedBy: null,
    limit: null,
    offset: null
  };

  rateSummaryDataTableColumns = [
    { id: 'name', heading: 'Rate Name' },
    { id: 'id', heading: 'Rate ID' },
    { id: 'active', heading: 'Active' },
    { id: 'rate', heading: 'Rate' },
    { id: 'num_sold', heading: '# Sold' },
    { id: 'limit', heading: 'Limit' },
    { id: 'num_available', heading: '# Available' },
    { id: 'num_term_30_days', heading: '# Terminating 30 Days' },
    { id: '#todo_num_wait_list', heading: '# Parkers On Wait List' },
    { id: '#todo_wait_list', heading: 'Wait List' },
    { id: '#todo_payor_alerts', heading: 'Payor Alerts' },
    { id: '#todo_parker_alerts', heading: 'Parkers Alerts' }
  ];

  ratesQueryFields = [
    { 'rates': [
      'id',
      'name',
      'active',
      'display_price',
      { 'current_monthly_fee': [
        'id'
      ] },
      { 'fees': [
        'id'
      ] },
      { 'sales_limits': [
        'month',
        'year',
        'limit',
        'total_parker_count',
        'terminating_parker_count'
      ] }
    ] }
  ];

  facilityId;
  facility = null;

  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);
    this.facilityId = urlSearchParams.get('facility');
  }

  componentDidMount() {
    const initializationTasks = [];

    if (this.facilityId) {
      initializationTasks.push(new Promise((resolve, reject) => {
        getFacility(this.facilityId).then(facility => {
          this.facility = facility;
          resolve();
        }, errors => {
          reject(errors);
        });
      }));
    }

    initializationTasks.push(new Promise((resolve, reject) => {
      Rate.getFieldAllowedValues(['active']).then(data => {
        const rateStatusOptions = [
          { value: null, label: 'All' },
          ...data.active.options
        ];
        this.ratesFilterFieldConfiguration.active = { options: rateStatusOptions };

        resolve();
      }, error => {
        reject([error]);
      });
    }));

    Promise.all(initializationTasks).then(() => {
      this.setState({
        pageInitializationComplete: true
      }, this.fetchRates());
    }, errors => {
      this.setState({
        pageInitializationComplete: true,
        pageInitializationErrors: errors.map(({ message }) => message)
      });
    });
  }

  fetchRates() {
    // NOTE ::
    // Rates are currently only fetched when the page is initially loaded,
    // and all state values are initially set to the defaults. If functionality
    // is added later to refresh the rates, this will reset state values to
    // ensure desired page element rendering.
    if (this.state.rateListQueryInProgress === false ||
      this.state.rates.length ||
      this.state.rateListQueryErrors.length
    ) {
      this.setState({ rateListQueryInProgress: true, rates: [], rateListQueryErrors: [] });
    }
    // END NOTE

    const queryOptions = (this.facilityId !== null) ?
      { filters: [{
        model: 'BILLING_PROFILE',
        field: 'facility_id',
        op: 'EQ',
        value: this.facilityId
      }]} : {};

    queryListRates(queryOptions, this.ratesQueryFields).then(response => {
      let stateChanges = {
        rateListQueryInProgress: false
      };

      if (response.errors) {
        stateChanges.rateListQueryErrors = response.errors.map(error => error.message);
      }
      else {
        const rateRawValues = response.data.listRates.rates;

        // const now = new Date();
        // const currentMonth = now.toLocaleString('en-US', { month: 'short' });
        // const currentYear = now.getFullYear();

        rateRawValues.forEach(rate => {
          rate.rate = rate.display_price;

          // TODO: Fix Sales Limits
          // const current_limit = rate.sales_limits.find(limit => limit.year === currentYear && limit.month === currentMonth);
          // if (current_limit) {
          //   rate.num_sold = current_limit.total_parker_count;
          //   rate.limit = current_limit.limit;
          //   rate.num_available = current_limit.limit - current_limit.total_parker_count;
          //   rate.num_term_30_days = current_limit.terminating_parker_count;
          // }
          // else {
          //   rate.num_sold = 'N/A';
          //   rate.limit = 'N/A';
          //   rate.num_available = 'N/A';
          //   rate.num_term_30_days = 'N/A';
          // }
        });

        this.rateData.rawValues = rateRawValues;
        stateChanges.rates = this.getRateSummaryDataTableRows();
      }

      this.setState({ ...stateChanges });
    });
  }


  getRateSummaryDataTableRows() {
    let rates = [];
    let rawValues = _.cloneDeep(this.rateData.rawValues);

    const { sortedBy, limit, offset } = this.rateData;

    // Filter
    if (this.state.ratesFilter.inputs.active !== null) {
      let tempRawValues = [];

      rawValues.forEach(rate => {
        if (rate.active === this.state.ratesFilter.inputs.active) {
          tempRawValues.push(rate);
        }
      });

      rawValues = tempRawValues;
    }
    this.rateData.filteredRowCount = rawValues.length;

    // SortedBy
    if (sortedBy !== null) {
      let sortFunction = null;
      switch (sortedBy.columnId) {
        case 'name':
        case 'id':
          sortFunction = (a, b) => {
            const diff = a[sortedBy.columnId].localeCompare(b[sortedBy.columnId]);
            return (sortedBy.direction === 'ASC' ? diff : -diff);
          };
          break;
        case 'rate':
          sortFunction = (a, b) => {
            const diff = parseFloat(a[sortedBy.columnId]) - parseFloat(b[sortedBy.columnId]);
            return (sortedBy.direction === 'ASC' ? diff : -diff);
          };
          break;
        case 'active':
        case 'num_sold':
        case 'limit':
        case 'num_available':
        case 'num_term_30_days':
          // TODO: Fix Sales Limits
          // sortFunction = (a, b) => {
          //   const diff = a[sortedBy.columnId] - b[sortedBy.columnId];
          //   return (sortedBy.direction === 'ASC' ? diff : -diff);
          // };
          break;
        default:
          // Remaining columns are all '@TODO', no need to sort.
      }
      if (sortFunction) {
        rawValues = rawValues.sort(sortFunction);
      }
    }

    // Limit
    if (limit !== null) {
      const startIndex = (offset === null) ? 0 : offset;
      const endIndex = startIndex + limit;
      rawValues = rawValues.slice(startIndex, endIndex);
    }

    for (let rate of rawValues) {
      let row = [];
      for (let column of this.rateSummaryDataTableColumns) {
        switch (column.id) {
          case 'name':
            row.push(`<a href="?page=parkchirp_rate${(this.facilityId !== null) ? `&facility=${this.facilityId}` : ''}&rate=${rate.id}">${rate.name}</a>`);
            break;
          case 'active':
            row.push(rate.active ? 'Active' : 'Inactive');
            break;
          case 'rate':
            row.push(`$${rate[column.id]}`);
            break;
          case 'num_sold':
          case 'limit':
          case 'num_available':
          case 'num_term_30_days':
            // TODO: Fix Sales Limits
            // row.push(`${rate[column.id]}`);
            row.push('-');
            break;
          case '#todo_num_wait_list':
          case '#todo_wait_list':
          case '#todo_payor_alerts':
          case '#todo_parker_alerts':
            row.push('@TODO');
            break;
          default:
            row.push(rate[column.id]);
        }
      }
      rates.push(row);
    }

    return rates;
  }


  updateRateSummaryDataTable() {
    this.setState({ rates: this.getRateSummaryDataTableRows() });
  }


  handleRateSummaryDataTableSortRequest = data => {
    this.rateData.sortedBy = data;

    this.updateRateSummaryDataTable();
  }


  handleRateSummaryDataTableLimitChange = data => {
    this.rateData.limit = data;
    this.rateData.offset = null;

    this.updateRateSummaryDataTable();
  }


  handleRateSummaryDataTablePageChange = data => {
    let offset = ((data - 1) * this.rateData.limit);
    this.rateData.offset = offset;

    this.updateRateSummaryDataTable();
  }


  _handleRatesFilterInputChange = inputId => {
    return value => {
      switch (inputId) {
        case 'active':
          value = (value === null) ? value : (value === 'true') ? true : false;
          break;
        default:
      }

      const ratesFilter = _.cloneDeep(this.state.ratesFilter);
      ratesFilter.inputs[inputId] = value;

      this.setState({ ratesFilter }, () => {
        this.updateRateSummaryDataTable();
      });
    };
  }


  renderNavigationBreadcrumbs() {
    const breadcrumbs = [];
    breadcrumbs.push(getBillingDashboardPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getRateListPageBreadcrumb(true));

    return (
      <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />
    );
  }


  renderPageHeader() {
    const facilityLink = (this.facilityId !== null) ? `&facility=${this.facilityId}` : '';

    const heading = 'Individual Rates';
    const subheading = (this.facility === null) ? null :
      this.facility.fields.facility_name.value;
    const actions = [
      <a href={`?page=parkchirp_rate${facilityLink}`} className="button button-primary page-action">Create New Rate</a>,
      <a href={`?page=parkchirp_general_settings${facilityLink}`} className="button button-primary page-action">Default Settings</a>
    ];

    return (
      <PageHeader heading={heading}
        subheading={subheading}
        actions={actions} />
    );
  }


  renderPageInitializationBlock() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;

    return (
      <React.Fragment>
        {(!pageInitializationComplete) &&
          <div className="parkchirp--page--user-message-container">
            <ProcessingIndicator userMessage="Initializing, please wait..." />
          </div>
        }
        {(pageInitializationComplete && pageInitializationErrors.length > 0) &&
          <div className="parkchirp--page--user-message-container">
            <div className="parkchirp--page--user-message">
              <p>The following errors occurred while initializing the page:</p>
              <ul>
                {pageInitializationErrors.map(error =>
                  <li key={performance.now()}>{error}</li>
                )}
              </ul>
            </div>
          </div>
        }
      </React.Fragment>
    );
  }


  renderRatesFilterForm() {
    const {
      ratesFilter,
      rateListQueryInProgress
    } = this.state;

    return (
      <div className="parkchirp--rate-summary--filter-form-container">
        <div className="parkchirp--rate-summary--filter-form">
          <h2>Filter</h2>
          <div className="parkchirp--rate-summary--filter-inputs">
            <Field label="Status"
              id="parkchirp--rate-summary-filter--active"
              layout="columns">
              <InputSelectField inputId="parkchirp--rate-summary-filter--active"
                value={ratesFilter.inputs.active}
                options={this.ratesFilterFieldConfiguration.active.options}
                onChange={this._handleRatesFilterInputChange('active')}
                editMode={true}
                disabledMode={rateListQueryInProgress}
              />
            </Field>
          </div>
        </div>
      </div>
    );
  }


  renderRateListDataTable() {
    const {
      rateListQueryInProgress,
      rateListQueryErrors,
      rates
    } = this.state;

    return (
      <React.Fragment>
        {(rateListQueryInProgress) &&
          <div className="parkchirp--page--user-message-container">
            <ProcessingIndicator userMessage="Retrieving data, please wait..." />
          </div>
        }
        {(!rateListQueryInProgress && rateListQueryErrors.length > 0) &&
          <div className="parkchirp--page--user-message-container">
            <div className="parkchirp--page--user-message">
              <p>The following errors occurred while retrieving the Rate data:</p>
              <ul>
                {rateListQueryErrors.map(error =>
                  <li key={performance.now()}>{error}</li>
                )}
              </ul>
            </div>
          </div>
        }
        {(!rateListQueryInProgress && rateListQueryErrors.length === 0) &&
          <DataTable id="rate-summary"
            rows={rates}
            columns={this.rateSummaryDataTableColumns}
            overallRowCount={this.rateData.filteredRowCount}
            currentLimit={this.rateData.limit}
            currentOffset={this.rateData.offset}
            sortedBy={this.rateData.sortedBy}
            onSortRequest={this.handleRateSummaryDataTableSortRequest}
            onLimitChange={this.handleRateSummaryDataTableLimitChange}
            onPageChange={this.handleRateSummaryDataTablePageChange}
          />
        }
      </React.Fragment>
    );
  }


  render() {
    const {
      pageInitializationComplete,
      pageInitializationErrors
    } = this.state;

    return (
      <div className="parkchirp--page parkchirp--page--rate-summary">
        {this.renderNavigationBreadcrumbs()}
        {this.renderPageHeader()}
        <div className="parkchirp--page-content">
          {(!pageInitializationComplete || pageInitializationErrors.length > 0) &&
            this.renderPageInitializationBlock()
          }
          {(pageInitializationComplete && pageInitializationErrors.length === 0) &&
            <React.Fragment>
              {this.renderRatesFilterForm()}
              {this.renderRateListDataTable()}
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}
export default RateListPage;


export function getRateListPageBreadcrumb(currentPage = false, facilityId = null) {
  const title = 'Individual Rates';
  const href = (currentPage) ? null :
    `?page=parkchirp_rates${(facilityId !== null) ? `&facility=${facilityId}` : ''}`;

  return { title, href };
}
